const validationMessages = {
  required: "This field is required.",
};

const validations = {
  required: (message: string = validationMessages.required) => ({ required: true, message }),
};

export { validationMessages, validations };
